export default __webpack_public_path__ + "static/media/pride.d42837e0.webp";